import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  Row,
  Col,
  Select,
  InputNumber,
  Button,
  Space,
  useSelect,
  Collapse,
  Typography,
  Descriptions,
  message,
  Radio,
} from '@pankod/refine-antd'
import { IProduct, ITestTrack } from 'interfaces'
import {
  calculateNationalAverageFromReports,
  isCalculateNationalAverage,
  NATIONAL_AVERAGE_MIN_SAMPLE,
  NATIONAL_AVERAGE_MIN_SCHOOLS,
} from 'helpers/nationalAverage'
import { useState } from 'react'
import { addNationalAverage, updateNationalAverage } from '../../gql/mutations'
import { productTypes } from 'utility/product.types'
const { Panel } = Collapse
type CreatePaperTemplateProps = {
  modalProps: ModalProps
  formProps: FormProps
  refetchData: () => void
  close: any
  // record: any;
}

export const CreateNationalAverage: React.FC<CreatePaperTemplateProps> = ({ modalProps, formProps, refetchData, close }) => {
  const [productName, setProductName] = useState({ id: '', name: '' })
  const [testTrackName, setTestTrackName] = useState({ id: '', name: '' })
  const [loading, setLoading] = useState<boolean>(false)
  const [type, setType] = useState<string>('tq')
  const [sktTestTracks, setSktTestTracks] = useState([])
  const [testTrackFilter, setTestTrackFilter] = useState<any>([])

  const { selectProps: productSelectProps, queryResult: productQueryResult } = useSelect<IProduct>({
    resource: 'products',
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'test_track_ids'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    filters: [
      { field: 'active', operator: 'eq', value: 'true' },
      { field: 'tq', operator: 'eq', value: 'false' },
      { field: 'type', operator: 'eq', value: `${type}` },
    ],
    fetchSize: 1000,
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const { selectProps: testtrackSelectProps, queryResult: testTrackQueryResult } = useSelect<ITestTrack>({
    resource: 'test_tracks',
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    filters: testTrackFilter,
    fetchSize: 1000,
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const handleProductChange = (value: any, option: any) => {
    const getSelectedProdDetails: any = productQueryResult?.data?.data.filter(prod => {
      if (prod?.id === value) {
        return prod || null
      }
    })
    const testTrackIds = getSelectedProdDetails[0]?.test_track_ids || []
    setTestTrackFilter([{ field: 'id', operator: 'in', value: testTrackIds }])
    setProductName({ id: option?.value, name: option?.label })
    formProps.form?.resetFields(['test_track_id'])
  }
  const handleTestTrackChange = (value: any, option: any) => {
    setTestTrackName({ id: option?.value, name: option?.label })
  }

  const OnSubmit = async (values: any) => {
    try {
      setLoading(true)
      //checking is it presented or not
      const isAlreadyAvailable = await isCalculateNationalAverage(values?.test_track_id, values?.product_id)
      if (isAlreadyAvailable?.status === true) {
        setLoading(false)
        message.error('Its already exisits ... you can update this only after 30 days')
        close()
        return false
      }
      const national_average_details: any = await calculateNationalAverageFromReports(values?.test_track_id, values?.product_id, type)
      if (national_average_details?.status && national_average_details?.meetsThreshold) {
        const national_average_data = {
          section_wise_average: national_average_details?.section_wise_average,
          product_id: values?.product_id || null,
          test_track_id: values?.test_track_id,
          product_name: productName?.name || null,
          test_track_name: testTrackName?.name || '',
          total_national_average: national_average_details?.total_national_average,
          tq: type === 'tq',
          type: type,
        }
        const responseFromInsertMutation: any =
          isAlreadyAvailable && isAlreadyAvailable?.canUpdate === true
            ? await updateNationalAverage(isAlreadyAvailable?.id, national_average_data)
            : await addNationalAverage(national_average_data)
        if (responseFromInsertMutation?.status) {
          setLoading(false)
          refetchData()
          message.success('National average for this Product and Track combination has been calculated successfully!')
          close()
          return true
        } else {
          setLoading(false)
          message.error('Something went wrong! Please contact AMS admin.')
          close()
          return false
        }
      } else {
        setLoading(false)
        // Refuse to store a thin/biased value. status:true but !meetsThreshold => not enough evidence.
        const insufficient = national_average_details?.status === true
        message.error(
          insufficient
            ? `Not enough data for a reliable national average: ${national_average_details?.sampleSize ?? 0} candidate(s) from ${national_average_details?.distinctSchools ?? 0} school(s). Minimum is ${NATIONAL_AVERAGE_MIN_SAMPLE} candidates across ${NATIONAL_AVERAGE_MIN_SCHOOLS} schools.`
            : 'Could not calculate the national average. Please try again later.'
        )
        setProductName({ id: '', name: '' })
        setTestTrackName({ id: '', name: '' })
        formProps.form?.resetFields()
      }
    } catch (err) {
      setLoading(false)
      console.log(err, 'error on submiting')
    }
  }

  return (
    <Modal
      {...modalProps}
      title="Generate National Average"
      onCancel={() => {
        formProps?.form?.resetFields()
        setLoading(false)
        close()
      }}
      footer={[
        <Button key="submit" type="primary" onClick={() => formProps?.form?.submit()} loading={loading} style={{ width: '100%' }}>
          {`Generate National Average (${type.toUpperCase()})`}
        </Button>,
      ]}
    >
      <div style={{ marginBottom: '1rem', textAlign: 'right' }}>
        <Radio.Group
          value={type}
          onChange={e => {
            setTestTrackName({ id: '', name: '' })
            setProductName({ id: '', name: '' })
            setTestTrackFilter([])
            formProps.form?.resetFields()
            setType(e.target.value)
          }}
          size="small"
        >
          {productTypes.map(type => (
            <Radio.Button value={type.value}>{type.label}</Radio.Button>
          ))}
        </Radio.Group>
      </div>

      <Form {...formProps} onFinish={values => OnSubmit(values).then(resp => formProps?.form?.resetFields())}>
        <Row gutter={[24, 0]}>
          {type === 'tq' ? (
            <Col xs={24} lg={24}>
              <Form.Item label="Test Track" name="test_track_id" rules={[{ required: true, message: 'Please select a test track' }]}>
                <Select {...testtrackSelectProps} onChange={handleTestTrackChange} />
              </Form.Item>
            </Col>
          ) : (
            <>
              <Col xs={24} lg={12}>
                <Form.Item label="Product" name="product_id" rules={[{ required: true, message: 'Please select a product' }]}>
                  <Select {...productSelectProps} onChange={handleProductChange} />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item label="Test Track" name="test_track_id" rules={[{ required: true, message: 'Please select a test track' }]}>
                  <Select {...testtrackSelectProps} onChange={handleTestTrackChange} disabled={productName?.name ? false : true} />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
      </Form>
    </Modal>
  )
}
